// @flow
import {fromJS, List, Set} from 'immutable';
import {Store} from 'client/framework';
import guideLevelListActions from './GuideLevelListActions';

export default class GuideLevelListStore extends Store {
  constructor(name: string) {
    super(name);
    this.initialData = fromJS({
      expandedGuides: []
    });

    this.setInitialData(this.initialData);
    this.handleTargeted(guideLevelListActions.GUIDE_TABLE_GUIDE_EXPANDED, this._expandGuide);
    this.handleTargeted(guideLevelListActions.GUIDE_TABLE_GUIDE_MINIMIZED, this._minimizeGuide);

    this.writeData('expandedGuides', new Set());
  }

  _expandGuide(guideId: string) {
    const guides = this.getExpandedGuideIds();
    this.writeData('expandedGuides', guides.add(guideId));
  }

  _minimizeGuide(guideId: string) {
    const guides = this.getExpandedGuideIds();
    this.writeData('expandedGuides', guides.remove(guideId));
  }

  getExpandedGuideIds(): Set<string> {
    return this.readData('expandedGuides');
  }

  isGuideExpanded(guideId: string): boolean {
    return this.getExpandedGuideIds().has(guideId);
  }
}
